import { Button } from 'antd';


export default () => {
  const renderData = window.__baseInfo.renderData || {};
  const {
    success, data = {}
  } = renderData;
  const {
    qrCodeUrl,
    subscribe
  } = data;
  function back() {
    window.wx.miniProgram.navigateBack();
  }
  function scanQRCode() {
    window.wx.scanQRCode({
      needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
      success: function (res) {
        console.log(res);
      }
    });
  }
  const contentStyle = {
    textAlign: 'center'
  };
  const buttonStyle = {
    marginTop: 24
  }
  if (!success) {
    return (
      <div style={contentStyle}>
        <div>服务号绑定失败</div>
        <Button onClick={back} type='primary' style={buttonStyle} >返回小程序</Button>
      </div>
    )
  }
  if (subscribe) {
    return (
      <div style={contentStyle}>
        <div>服务号绑定成功</div>
        <Button onClick={back} type='primary' style={buttonStyle} >返回小程序</Button>
      </div>
    )
  }

  return (
    <div style={contentStyle}>
      <div>
        <img style={{width: 246}} src={`https://img.yxdj.tech/${qrCodeUrl}`} />
      </div>
      <div style={{
        fontSize: '16px',
        fontWeight: 'bold',
        marginTop: 24
      }}>长按二维码关注服务号。<br />或者截图后，进行扫码关注.</div>
    </div>
  )
}